import React from 'react';
import { Navigate } from 'react-router-dom';

const TenantBasedHome = ({ profile }) => {
  const { tenant_id } = profile;

  // Logic for tenant-based redirection
  if (tenant_id === "1") {
    // For tenant_id 1, redirect to dashboard
    return <Navigate to="/dashboard" replace />;
  } else if (tenant_id === "3") {
    // For tenant_id 3, redirect to marketing-dashboard
    return <Navigate to="/marketing-dashboard" replace />;
  } else if (tenant_id === "5") {
    // For tenant_id 5, redirect to landing page
    return <Navigate to="/landing" replace />;
  } else {
    // Default fallback to dashboard
    return <Navigate to="/dashboard" replace />;
  }
};

export default TenantBasedHome; 